/**
 * Standalone module for the AI-assistant mode constant.
 *
 * Kept separate from `AiAssistantDialog.tsx` so consumers (DoBox, the Sidebar
 * compose menu, Discover) can read the mode value without statically importing
 * the heavy dialog component + its flow-generation hooks. This is what lets the
 * dialog itself be lazy-loaded.
 */
export const ASSISTANT_MODE = {
  FLOW: 'flow',
  DOBOX: 'dobox',
} as const;

export type AssistantMode =
  (typeof ASSISTANT_MODE)[keyof typeof ASSISTANT_MODE];
